<template>
    <div>
        <b-modal
            no-stacking
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            hide-footer
            v-model="flashDropoff.show"
            size="xl"
        >
            <template slot="modal-header">
                <div slot="header" class="bg-white border-0 w-100">
                    <div class="row align-items-center">
                        <div class="col-6">
                            <h3 class="mb-0">นำเข้าพัสดุ Flash Express Dropoff <span class="text-danger"></span></h3>
                        </div>
                    </div>
                </div>
            </template>
            <card show type="seconday" class="m--4">
                <div class="row">
                    <div class="col-md-12">
                        <ScanTrackingFlashDropoff 
                            ref="flashDropoff"
                            :isLoading="flashDropoff.isLoadingFlashDropoff"
                            isPlaceholder=""
                            :isError="flashDropoff"
                            :isTracking="flashDropoff"
                            courierCode="FLEDS"
                            :listSize="listSize"
                            :shopId="shopId"
                            @checkTracking="checkTrackingFlashDropoff()"
                            @checkTrackingRegx="checkTrackingRegx($event)"
                        />
                        <div class="container-fluid px-5">
                            <div class="row">
                                <h4>รายการพัสดุ</h4>
                            </div>
                            <div class="row">
                                <div class="scroll-table scroll-bar-pop m-h-380 scrollbar-style table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr class="text-center">
                                                <th>#</th>
                                                <th>Tracking no.</th>
                                                <th>น้ำหนัก {{ $THEME.unitKG ? '( กิโลกรัม )' : '( กรัม )' }}</th>
                                                <th>ขนาดพัสดุ (เซนติเมตร)</th>
                                                <th>จัดการ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(item, index) in flashOrder">
                                                <tr :key="index" class="text-center table-white">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ item.dropoff_tracking_code }}</td>
                                                    <td>{{ ($THEME.unitKG) ? (item.parcel.weight/1000) : item.parcel.weight }}</td>
                                                    <td>{{item.parcel.width+'x'+item.parcel.length+'x'+item.parcel.height}}</td>
                                                    <td>
                                                        <div class="d-flex">
                                                            <button class="btn btn-link text-danger p-2 hvr-grow" @click="deleteFlashOrder( index )">
                                                                <i class="far fa-trash-alt"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="mt-4 w-100">
                                <div class="row text-center">
                                    <div class="col-12">
                                        <b-button class="px-5-mx-4" variant="secondary" @click="clearFlashDropoff()">
                                            <i class="fas fa-circle-notch fa-spin" v-if="isLoadCancelBatch"></i>
                                            ยกเลิก
                                        </b-button>
                                        <b-button class="px-5 mx-4" variant="success" @click="$emit('confirmCreateFlashDropoff', flashOrder)">
                                            ยืนยัน
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </b-modal>
    </div>
</template>

<script>
    import customTheme from '@/config/POPTheme'
    import { sound } from '@/plugins/soundEffect.js'
    import { searchTrackingFlashDropoff } from "@/axios/search.js"
    import { uploadImageDropoff } from "@/axios/dropoff.js"
    import ScanTrackingFlashDropoff from '@/components/custom/pos/ScanTrackingFlashDropoff'

    export default {
        name: 'FlashDropoff',
        props: {
            flashDropoff: Object,
            count: Number,
            addressFrom: Object,
            cartFlashDropoff: Array,
            listSize: Object,
            shopId: [Number, String]
        },
        data() {
            const dropoffFlashOption = customTheme.dropoffFlashOption || {}

            return {
                flashOrder: [],
                barchId: '',
                isLoadCancelBatch: false,
                customDropoff: {
                    manual: dropoffFlashOption.manual,
                    vdoHowTo: dropoffFlashOption.vdoHowTo,
                    limit: dropoffFlashOption.limit
                }
            }
        },
        components: {
            ScanTrackingFlashDropoff
        },
        methods: {
            addToFlashOrder(response) {
                sound('positiveBeep')

                this.flashDropoff.parcel = {
                    weight: response.parcel.weight,
                    width: response.parcel.width,
                    length: response.parcel.length,
                    height: response.parcel.height
                }
                this.flashDropoff.queryId = response.query_id

                this.flashOrder.push(this.setFormatOrderFlashDropoff(response.tracking_code))
                this.clearForm()
                this.$refs.flashDropoff.$refs.searchTracking.focus()
            },
            requireMoreDetail(response) {
                sound('beepFail')

                switch(response.message) {
                    case 'NOT_FOUND':
                        this.flashDropoff.errorMsg = 'หมายเลขพัสดุไม่ถูกต้อง'
                        this.flashDropoff.action = {
                            photo: false,
                            dim: false,
                            weight: false,
                        }
                        this.flashDropoff.images = []
                        break
                    case 'NO_PARCEL_INFO':
                        this.flashDropoff.errorMsg = 'กรุณาวัดขนาดพัสดุใหม่อีกครั้ง'
                        this.flashDropoff.action = {
                            photo: false,
                            dim: true,
                            weight: true,
                        }
                        this.flashDropoff.images = []
                        break
                    case 'ALREADY_BOOKED': 
                        this.flashDropoff.errorMsg = 'เลขพัสดุนี้ถูกใช้งานแล้ว'
                        this.flashDropoff.action = {
                            photo: false,
                            dim: true,
                            weight: true,
                        }
                        this.flashDropoff.images = []
                        break
                    case 'REQUIRED_PHOTO':
                        this.flashDropoff.errorMsg = 'กรุณาอัปโหลดรูปภาพของพัสดุ'
                        this.flashDropoff.action = {
                            photo: true,
                            dim: false,
                            weight: false,
                        }
                        this.flashDropoff.images = []
                        break
                    default:
                        break
                }

                this.flashDropoff.queryId = response.query_id
                this.flashDropoff.parcel = {
                    weight: response.parcel.weight,
                    width: response.parcel.width,
                    length: response.parcel.length,
                    height: response.parcel.height
                }

                this.flashDropoff.isLoadingFlashDropoff = false
            },
            async checkTrackingFlashDropoff() {
                this.flashDropoff.isLoadingFlashDropoff = true
                this.flashDropoff.errorMsg = ''

                if ((this.flashOrder.length + this.cartFlashDropoff.length) > this.customDropoff.limit - 1) {
                    sound('beepFail')
                    this.flashDropoff.errorMsg = `ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจาก BatchId รองรับจำนวน Shipment ได้สูงสุด ` + this.customDropoff.limit + ` Shipment`
                    this.flashDropoff.isLoadingFlashDropoff = false
                    return false
                }

                let uniqueTracking = this.flashOrder.filter(flash => {
                    return flash.dropoff_tracking_code === this.flashDropoff.trackingCode
                })

                let uniqueCartTracking = this.cartFlashDropoff.filter(flash => {
                    return flash.dropoff_tracking_code === this.flashDropoff.trackingCode
                })

                if (uniqueTracking.length > 0 || uniqueCartTracking.length > 0) {
                    sound('beepFail')
                    this.flashDropoff.errorMsg = `ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจากหมายเลขพัสดุ ${this.flashDropoff.trackingCode} นี้ ถูกใช้งานไปแล้ว`
                    this.flashDropoff.isLoadingFlashDropoff = false
                    return false
                }

                const _this = this

                if (!this.flashDropoff.action.photo) {
                    const payload = {
                        tracking_code: this.flashDropoff.trackingCode,
                        query_id: this.flashDropoff.queryId,
                        parcel: {
                            weight: this.flashDropoff.parcel.weight,
                            width: this.flashDropoff.parcel.width,
                            length: this.flashDropoff.parcel.length,
                            height: this.flashDropoff.parcel.height,
                        }
                    }
                    
                    await searchTrackingFlashDropoff(payload).then((res) => {
                        if (res.message.trim() === 'OK') {
                            _this.addToFlashOrder(res)
                        } else {
                            _this.requireMoreDetail(res)
                        }
                    }).catch(e => {
                        sound('beepFail')
                        this.flashDropoff.errorMsg = e
                        this.flashDropoff.isLoadingFlashDropoff = false
                    })
                } else {
                    const payload = {
                        image: (this.flashDropoff.images && this.flashDropoff.images[0])?(this.flashDropoff.images[0].preview):'',
                        query_id: this.flashDropoff.queryId
                    }

                    await uploadImageDropoff(payload).then((res) => {
                        this.flashDropoff.images[0].url = res.image_url

                        _this.addToFlashOrder({ 
                            parcel: {
                                ...this.flashDropoff.parcel
                            },
                            tracking_code: this.flashDropoff.trackingCode,
                            query_id: this.flashDropoff.query_id
                         })
                    }).catch((e) => {
                        sound('beepFail')
                        this.flashDropoff.errorMsg = e
                        this.flashDropoff.isLoadingFlashDropoff = false
                    })
                }
            },
            setFormatOrderFlashDropoff(flashTrackingCode) {
                let count = this.count

                let flashDropoff = {
                    error: {
                        status: false,
                        data: [],
                        msg: null
                    },
                    type: 'ship',
                    dropoff_type: 'FLASH_DROPOFF',
                    num: 1,
                    name: 'FLASH DROPOFF',
                    key: this.flashDropoff.code,
                    parcel: {
                        weight: (this.$THEME.unitKG) ? (this.flashDropoff.parcel.weight * 1000) : this.flashDropoff.parcel.weight,
                        width: this.flashDropoff.parcel.width,
                        length: this.flashDropoff.parcel.length,
                        height: this.flashDropoff.parcel.height,
                        key_size: '',
                        weightKG: this.flashDropoff.parcel.weight / 1000
                    },
                    price: '0.00',
                    rate_remote_area: '0.00',
                    cross_price: '0.00',
                    cod_amount: '0.00',
                    dropoff_tracking_code: flashTrackingCode,
                    consignment_no_ref: '',
                    check: count++,
                    images: this.flashDropoff.images.map((img) => img.url),
                    query_id: this.flashDropoff.queryId,
                    from: {
                        name: this.addressFrom.name,
                        address: this.addressFrom.address,
                        district: this.addressFrom.district,
                        state: this.addressFrom.state,
                        province: this.addressFrom.province,
                        postcode: this.addressFrom.postcode,
                        tel: this.addressFrom.tel
                    },
                    to: {
                        name: flashTrackingCode,
                        address: '-',
                        district: '-',
                        province: '-',
                        state: '-',
                        postcode: '10000',
                        tel: '-'
                    }
                }

                this.$emit('update:count', count)

                return flashDropoff
            },
            checkTrackingRegx(event) {
                let val = event.target.value.toUpperCase()

                if (val) {
                    val = val.trim().split(' ')[0]
                }

                let validateBarcode = /^(TH)[0-9a-zA-Z]+$/i.test(val)
                this.flashDropoff.trackingCode = val

                if (validateBarcode == false) {
                    this.flashDropoff.errorMsg = 'ไม่พบหมายเลขพัสดุดังกล่าว'

                    return false
                }
            },
            async deleteFlashOrder( indexOfOrder ){
                this.flashOrder.splice( indexOfOrder , 1)
            },
            async clearFlashDropoff() {
                this.flashOrder = [];
                this.flashDropoff.show = false
                this.flashDropoff.size.boxSize = '';
                this.clearForm()
            },
            clearForm() {
                    this.flashDropoff.isLoadingFlashDropoff = false
                    this.flashDropoff.trackingCode = ''
                    this.flashDropoff.errorMsg = ''
                    this.flashDropoff.queryId = '';
                    this.flashDropoff.images = []
                    this.flashDropoff.action = {
                        photo: false,
                        dim: false,
                        weight: false
                    }

                    if (!this.flashDropoff.favoriteDimension) {
                        Object.keys(this.flashDropoff.parcel).forEach(key => {
                            if (!['weight', 'weightKG'].includes(key)) {
                                this.flashDropoff.parcel[key] = ''
                            }
                        })
                        this.flashDropoff.size.boxSize = ''
                    }
    
                    if (!this.flashDropoff.favoriteWeight) {
                        this.flashDropoff.parcel.weight = ''
                        this.flashDropoff.parcel.weightKG = ''
                    }
                },
        },
    }
</script>